import React from 'react';

const TimeFieldMockup = ({ value, toDisplayFormat }) => <div className="m-table-obvious-inner">{toDisplayFormat(value)}</div>;

export default TimeFieldMockup;
